import { createSelector } from '@ngrx/store';

import { RootState } from '../../root-store/root.state';

export const selectSeHeaderToolbarFeature = () => (state: RootState) => state.headerToolbar;

export const selectHeaderToolbarIsNavigateOnClickEnabled = createSelector(
    selectSeHeaderToolbarFeature(),
    (state) => state.isNavigateOnClickEnabled,
);
